<template>
  <el-container>
    <el-header>
      <Navbar
        :needUpdate.sync="needUpdate"
        :dialogLoginVisible.sync="loginFormShow"
        :needRecharge.sync="needRecharge"
      ></Navbar>
    </el-header>
    <el-container class="main_cont">
      <NavbarLeft active_idx="/image-image"></NavbarLeft>
      <el-main style="height: 100%; padding: 0">
        <el-container style="height: 100%">
          <el-main
            style="
              background-color: #0b0b1f;
              padding: 0px 0px;
              position: relative;
              display: flex;
              overflow-y: hidden;
            "
          >
            <div style="width: 50%; padding-right: 9px; position: relative">
              <div
                ref="replace_left"
                style="
                  border-radius: 14px;
                  padding: 20px;
                  box-sizing: border-box;
                  height: calc(100% - 25px);
                  margin-bottom: 26px;
                  overflow-y: auto;
                  overflow-x: hidden;
                  padding-bottom: 140px;
                "
              >
                <div
                  class="d-flex"
                  style="
                    min-width: 80px;
                    flex: 1;
                    font-size: 14px;
                    color: rgb(202, 202, 212);
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    margin-bottom: 18px;
                  "
                >
                  <span
                    style="font-size: 12px; color: #ef4545; margin-right: 4px"
                    >*</span
                  >上传参考图
                  <span style="color: gray"
                    >（小于5M，格式：jpg、png、jpeg）</span
                  >
                </div>

                <div
                  style="flex: 1; flex-shrink: 0; position: relative"
                  class="left"
                >
                  <el-upload
                    class="upload-demo"
                    :auto-upload="false"
                    drag
                    action=""
                    accept=".jpg, .png ,.jpeg"
                    :before-upload="checkLogin"
                    :on-change="getFile"
                    multiple
                    :show-file-list="false"
                    style="margin: 0 auto; background-color: rgb(17, 18, 37)"
                    :style="{
                      height:
                        (main_height < main_width ? main_height : main_width) +
                        'px',
                      width:
                        (main_height < main_width ? main_height : main_width) +
                        'px',
                    }"
                    v-if="!proofImage"
                  >
                    <div
                      style="
                        width: 100%;
                        height: 100%;
                        position: relative;
                        justify-content: center;
                        align-items: center;
                      "
                      :style="{
                        height:
                          (main_height < main_width
                            ? main_height
                            : main_width) + 'px',
                        width:
                          (main_height < main_width
                            ? main_height
                            : main_width) + 'px',
                      }"
                      class="tool-main-cont d-flex"
                      v-if="!proofImage"
                      fit="contain"
                    >
                      <div>
                        <el-image
                          style="width: 120px; height: 120px; cursor: pointer"
                          :src="require('../assets/img/textform/pic.png')"
                          fit="contain"
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <div style="color: #cacad4">
                          将图片拖至此处，或
                          <span style="color: #006fff">点击上传</span>
                        </div>
                      </div>
                    </div>
                  </el-upload>

                  <div
                    style="
                      margin: 0 auto;
                      background-color: rgb(17, 18, 37);
                      justify-content: center;
                      position: relative;
                    "
                    :style="{
                      height:
                        (main_height < main_width ? main_height : main_width) +
                        'px',
                      width:
                        (main_height < main_width ? main_height : main_width) +
                        'px',
                    }"
                    :class="{
                      pen_type: toolsType_pen,
                      eraser_type: toolsType_eraser,
                    }"
                    v-show="proofImage"
                  >
                    <canvas
                      v-if="canvasWidth"
                      id="canvas1"
                      :width="canvasWidth"
                      :height="canvasHeight"
                      style="
                        position: absolute;
                        left: 50%;
                        z-index: 99;
                        top: 50%;
                      "
                      :style="{
                        marginLeft: -canvasWidth / 2 + 'px',
                        marginTop: -canvasHeight / 2 + 'px',
                      }"
                    ></canvas>
                    <canvas
                      v-if="canvasWidth"
                      id="canvas2"
                      :width="canvasWidth"
                      :height="canvasHeight"
                      style="
                        position: absolute;
                        left: 50%;
                        z-index: 100;
                        top: 50%;
                      "
                      :style="{
                        marginLeft: -canvasWidth / 2 + 'px',
                        marginTop: -canvasHeight / 2 + 'px',
                      }"
                    ></canvas>

                    <div
                      class="d-flex"
                      @click.stop="deleteProofImage"
                      style="
                        width: 40px;
                        height: 40px;
                        background: rgba(0, 0, 0, 0.5);
                        border-radius: 6px;
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        z-index: 101;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <el-image
                        style="width: 20px; height: 20px; cursor: pointer"
                        :src="require('../assets/img/textform/del.png')"
                        fit="contain"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </div>
                  </div>

                  <div
                    :style="{
                      width:
                        (main_height < main_width ? main_height : main_width) +
                        'px',
                    }"
                    style="height: 40px; margin: 0 auto"
                  >
                    <div
                      class="d-flex"
                      style="justify-content: flex-end; margin-top: 6px"
                      v-if="proofImage"
                    >
                      <el-popover
                        placement="bottom"
                        width="170"
                        trigger="hover"
                        popper-class="imageToimage"
                      >
                        <div style="text-indent: 12px">重绘涂抹的区域大小</div>
                        <el-slider
                          v-model="toolslineWidth"
                          :min="10"
                          :max="100"
                          :step="1"
                          style="width: 146px"
                        ></el-slider>
                        <el-image
                          @click="changeTools('pen')"
                          slot="reference"
                          style="
                            width: 36px;
                            height: 36px;
                            cursor: pointer;
                            margin-right: 10px;
                          "
                          :src="require('../assets/img/textform/pen_act.png')"
                          fit="contain"
                          v-if="toolsType == 'pen'"
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image
                          @click="changeTools('pen')"
                          slot="reference"
                          style="
                            width: 36px;
                            height: 36px;
                            cursor: pointer;
                            margin-right: 10px;
                          "
                          :src="require('../assets/img/textform/pen.png')"
                          fit="contain"
                          v-else
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-popover>

                      <el-popover
                        placement="bottom"
                        width="170"
                        trigger="hover"
                        popper-class="imageToimage"
                      >
                        <div style="text-indent: 12px">擦除涂抹的区域大小</div>
                        <el-slider
                          v-model="toolsEraserWidth"
                          :min="10"
                          :max="100"
                          :step="1"
                          style="width: 146px"
                        ></el-slider>
                        <el-image
                          @click="changeTools('eraser')"
                          slot="reference"
                          style="width: 36px; height: 36px; cursor: pointer"
                          :src="
                            require('../assets/img/textform/eraser_act.png')
                          "
                          fit="contain"
                          v-if="toolsType == 'eraser'"
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image
                          @click="changeTools('eraser')"
                          slot="reference"
                          style="width: 36px; height: 36px; cursor: pointer"
                          :src="require('../assets/img/textform/eraser.png')"
                          fit="contain"
                          v-else
                        >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-popover>
                    </div>
                  </div>
                </div>

                <imageImageForm
                  ref="imageImageFormRef"
                  :acData="ac_data"
                  :model_num="model_num"
                ></imageImageForm>
                <div
                  style="
                    position: absolute;
                    left: 10px;
                    bottom: 10px;
                    right: 20px;
                    background-color: rgb(11, 11, 31);
                  "
                >
                  <div
                    class="d-flex"
                    style="
                      font-size: 16px;
                      font-family: PingFangSC-Medium, PingFang SC;
                      font-weight: 500;
                      color: #828292;
                      margin-bottom: 11px;
                      align-items: flex-end;
                      min-height: 40px;
                      position: relative;
                    "
                  >
                    <div style="width: 130px">
                      <Prompt
                        :mainheight="main_height"
                        :promptArr="promptArr"
                        @ClickPrompt="ClickPrompt"
                        :closePrompt="closePrompt"
                        drawtype="image"
                        :promptLanguage.sync="promptLanguage"
                        @ChangePrompt="ChangePrompt"
                      />
                    </div>

                    <div
                      v-if="taskInterrogateFlag"
                      class="getpromptBtn d-flex"
                      style="
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        border: 1px solid #006fff;
                        opacity: 0.5;
                        background: #0b0b1f;
                        color: #006fff;
                        z-index: 999;
                        position: relative;
                      "
                    >
                      反向提取提示词
                    </div>
                    <div
                      v-else
                      class="getpromptBtn d-flex"
                      style="
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        z-index: 999;
                        position: relative;
                      "
                      @click="taskInterrogate"
                    >
                      反向提取提示词
                    </div>

                    <div style="flex: 1; text-align: center; z-index: 999">
                      <el-button
                        type="danger"
                        style="background-color: #d74444"
                        v-if="img_create_loading"
                        @click="task_interrupt_click"
                        >取消任务</el-button
                      >
                    </div>
                    <!-- <div style="width: 200px;text-align: right;" v-if="ac_data.points">{{ ac_data.points ? `剩余积分:${ac_data.points}` : "" }}</div> -->
                  </div>

                  <div
                    class="d-flex bottom-cont"
                    style="
                      align-items: center;
                      z-index: 999;
                      position: relative;
                    "
                  >
                    <div
                      style="flex: 1; align-items: center; position: relative"
                      class="d-flex"
                    >
                      <el-input
                        id="myTextarea"
                        resize="none"
                        type="textarea"
                        :autosize="{ minRows: 1, maxRows: 3 }"
                        placeholder="请输入生成文案…"
                        v-model="formVuex.prompt"
                        :disabled="img_create_loading"
                        style="background-color: #222337"
                        @input.native="inputValue($event)"
                        @change.native="inputChangeValue($event)"
                        ref="text_input"
                      >
                      </el-input>
                      <SensitiveCont
                        v-if="isSensitive"
                        :text="stext"
                        :sensitiveData="sensitiveData"
                        @ListenSensitive="ListenSensitive"
                      ></SensitiveCont>

                      <div
                        style="
                          background: #111225;
                          padding: 1px 2px 2px;
                          max-height: 31px;
                          min-width: 112px;
                        "
                        class="radio_group"
                      >
                        <el-radio-group
                          v-model="promptLanguage"
                          size="mini"
                          fill="#006FFF"
                          class="language_label"
                        >
                          <el-radio-button label="中文"></el-radio-button>
                          <el-radio-button label="英文"></el-radio-button>
                        </el-radio-group>
                      </div>
                    </div>
                    <div @click="search" class="generate">
                      <div
                        style="
                          font-size: 20px;
                          font-family: PingFangSC-Medium, PingFang SC;
                          font-weight: 500;
                          color: #ffffff;
                          margin-top: 8px;
                        "
                      >
                        生成
                      </div>
                      <div
                        style="
                          font-size: 10px;
                          font-family: PingFangSC-Medium, PingFang SC;
                          font-weight: 500;
                          color: #ffffff;
                          transform: scale(0.8);
                          margin-top: -2px;
                        "
                      >
                        <span v-if="ac_data.vip">VIP生效中，无需积分</span>
                        <span v-else
                          >本次消耗积分: {{ formVuex.batch_size * 8 }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style="
                width: 50%;
                padding-left: 9px;
                overflow-y: hidden;
                height: 100%;
              "
              ref="replace_right"
            >
              <div
                class="replace_left history"
                style="
                  border-radius: 14px;
                  margin-top: 20px;
                  padding: 20px;
                  box-sizing: border-box;
                  height: calc(100% - 25px);
                  overflow-y: auto;
                  overflow-x: hidden;
                  padding-bottom: 20px;
                "
              >
                <div style="height: 100%">
                  <div
                    class="scroll-cont"
                    style="
                      scrollbar-width: none;
                      overflow-y: auto;
                      font-family: PingFangSC-Medium, PingFang SC;
                      font-weight: 500;
                      color: #828292;
                      box-sizing: border-box;
                    "
                  >
                    <div
                      class="bd-content content d-flex"
                      style="flex-direction: column"
                      id="bd_content_img_img"
                    >
                      <div
                        style="flex: 1; flex-shrink: 0"
                        class="tool-main"
                        ref="tool_main"
                      >
                        <div
                          class="tool-main-cont d-flex"
                          v-if="imgList.length == 0"
                          :style="{
                            height:
                              (main_height < main_width
                                ? main_height
                                : main_width) + 'px',
                            width:
                              (main_height < main_width
                                ? main_height
                                : main_width) + 'px',
                          }"
                          style="margin-bottom: 20px"
                        >
                          <div
                            v-if="
                              img_create_loading &&
                              curStatus == 0 &&
                              curObj.index != 0 &&
                              curObj.total != 0
                            "
                            style="margin-top: 35px"
                          >
                            任务排在 {{ curObj.index }}/{{ curObj.total }}
                            队列中，请耐心等待
                            <vue-typed-js
                              style="display: inline-block; min-width: 14px"
                              :strings="['...']"
                              :loop="true"
                              :startDelay="0"
                              :typeSpeed="20"
                              :backSpeed="50"
                              :showCursor="false"
                            >
                              <span class="typing"></span>
                            </vue-typed-js>
                          </div>
                          <div
                            v-if="
                              img_create_loading &&
                              curStatus == 0 &&
                              curObj.index == 0 &&
                              curObj.total == 0
                            "
                            style="margin-top: 35px"
                          >
                            任务即将开始，请耐心等待
                            <vue-typed-js
                              style="display: inline-block; min-width: 14px"
                              :strings="['...']"
                              :loop="true"
                              :startDelay="0"
                              :typeSpeed="20"
                              :backSpeed="50"
                              :showCursor="false"
                            >
                              <span class="typing"></span>
                            </vue-typed-js>
                          </div>
                          <el-progress
                            type="circle"
                            :percentage="
                              curObj.progress - 0
                                ? (curObj.progress * 100).toFixed(0) - 0
                                : 1
                            "
                            text-color="#fff"
                            color="#006FFF"
                            v-if="
                              img_create_loading &&
                              curStatus == 1 &&
                              curObj.progress
                            "
                          ></el-progress>
                          <div
                            v-if="
                              img_create_loading &&
                              curStatus == 1 &&
                              curObj.progress &&
                              curObj.etaRelative >= 0
                            "
                            style="margin-top: 35px"
                          >
                            排队生成中，请稍候
                            <vue-typed-js
                              style="display: inline-block; min-width: 14px"
                              :strings="['...']"
                              :loop="true"
                              :startDelay="0"
                              :typeSpeed="20"
                              :backSpeed="50"
                              :showCursor="false"
                            >
                              <span class="typing"></span>
                            </vue-typed-js>
                          </div>
                          <div
                            v-else-if="img_create_loading && curStatus != 0"
                            style="margin-top: 35px"
                          >
                            处理中
                            <vue-typed-js
                              style="display: inline-block; min-width: 14px"
                              :strings="['...']"
                              :loop="true"
                              :startDelay="0"
                              :typeSpeed="20"
                              :backSpeed="50"
                              :showCursor="false"
                            >
                              <span class="typing"></span>
                            </vue-typed-js>
                          </div>
                        </div>
                        <div
                          v-if="imgList.length > 0"
                          style="
                            text-align: center;
                            position: relative;
                            margin-bottom: 20px;
                          "
                        >
                          <div
                            style="
                              position: relative;
                              margin: 0 auto !important;
                              border-radius: 8px;
                            "
                            :style="{
                              height:
                                (main_height < main_width
                                  ? main_height
                                  : main_width) + 'px',
                              width:
                                (main_height < main_width
                                  ? main_height
                                  : main_width) + 'px',
                            }"
                            class="exit_hover"
                          >
                            <el-carousel
                              :height="
                                (main_height < main_width
                                  ? main_height
                                  : main_width) + 'px'
                              "
                              arrow="never"
                              :autoplay="false"
                              :initial-index="imgIdx"
                              indicator-position="none"
                              ref="cardShow"
                              class="images_"
                              v-viewer="{
                                movable: true,
                                navbar: false,
                                toolbar: true,
                                title: false,
                                fullscreen: false,
                                rotatable: false,
                                scalable: false,
                              }"
                            >
                              <el-carousel-item
                                v-for="(item, idx) in imgList"
                                :key="idx"
                              >
                                <el-image
                                  :src="item.image"
                                  class="avatar"
                                  fit="contain"
                                  style="margin-left: 5px"
                                  :style="{
                                    width:
                                      (main_height < main_width
                                        ? main_height
                                        : main_width) + 'px',
                                    height:
                                      (main_height < main_width
                                        ? main_height
                                        : main_width) + 'px',
                                  }"
                                  v-if="item.image"
                                >
                                  <div
                                    slot="placeholder"
                                    class="image-slot"
                                  ></div>
                                </el-image>
                                <el-image
                                  :fit="'contain'"
                                  :style="{
                                    height:
                                      (main_height < main_width
                                        ? main_height
                                        : main_width) + 'px',
                                    width:
                                      (main_height < main_width
                                        ? main_height
                                        : main_width) + 'px',
                                  }"
                                  style="
                                    margin: 0 auto !important;
                                    border-radius: 8px;
                                  "
                                  :src="
                                    require('../assets/img/textform/forbid.png')
                                  "
                                  v-else
                                >
                                  <div
                                    slot="placeholder"
                                    class="image-slot"
                                  ></div>
                                </el-image>
                              </el-carousel-item>
                            </el-carousel>

                            <el-tooltip
                              popper-class="tps"
                              class="item"
                              effect="dark"
                              :enterable="false"
                              content="下载"
                              placement="right"
                              :close-delay="10"
                            >
                              <el-image
                                style="
                                  width: 36px;
                                  height: 36px;
                                  position: absolute;
                                  right: -54px;
                                  top: 10px;
                                  cursor: pointer;
                                "
                                :src="
                                  require('../assets/img/textform/download.png')
                                "
                                fit="contain"
                                @click="downloadImage"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </el-tooltip>

                            <el-tooltip
                              popper-class="tps"
                              class="item"
                              effect="dark"
                              :enterable="false"
                              content="分享"
                              placement="right"
                              :close-delay="10"
                            >
                              <el-image
                                style="
                                  width: 36px;
                                  height: 36px;
                                  position: absolute;
                                  right: -54px;
                                  top: 60px;
                                  cursor: pointer;
                                "
                                :src="
                                  require('../assets/img/textform/share.png')
                                "
                                fit="contain"
                                @click="shareImg"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </el-tooltip>

                            <el-tooltip
                              popper-class="tps"
                              class="item"
                              effect="dark"
                              :enterable="false"
                              content="发布到图生图局部重绘"
                              placement="right"
                              :close-delay="10"
                            >
                              <el-image
                                style="
                                  width: 36px;
                                  height: 36px;
                                  position: absolute;
                                  right: -54px;
                                  top: 110px;
                                  cursor: pointer;
                                "
                                :src="
                                  require('../assets/img/textform/repaint.png')
                                "
                                fit="contain"
                                @click="repainting_publish"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </el-tooltip>

                            <el-tooltip
                              popper-class="tps"
                              class="item"
                              effect="dark"
                              :enterable="false"
                              content="发布到广场"
                              placement="right"
                              v-if="imgList[imgIdx].verify == -1"
                              :close-delay="10"
                            >
                              <el-image
                                style="
                                  width: 36px;
                                  height: 36px;
                                  position: absolute;
                                  right: -54px;
                                  top: 160px;
                                  cursor: pointer;
                                "
                                :src="
                                  require('../assets/img/textform/square.png')
                                "
                                fit="contain"
                                @click="painting_publish"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </el-tooltip>
                            <el-tooltip
                              popper-class="tps"
                              class="item"
                              effect="dark"
                              :enterable="false"
                              content="取消发布"
                              placement="right"
                              v-else-if="imgList[imgIdx].verify == 1"
                              :close-delay="10"
                            >
                              <el-image
                                style="
                                  width: 36px;
                                  height: 36px;
                                  position: absolute;
                                  right: -54px;
                                  top: 160px;
                                  cursor: pointer;
                                "
                                :src="
                                  require('../assets/img/textform/square2.png')
                                "
                                fit="contain"
                                @click="painting_cancel"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </el-tooltip>
                            <el-tooltip
                              popper-class="tps"
                              class="item"
                              effect="dark"
                              :enterable="false"
                              content="审核中"
                              placement="right"
                              v-else-if="imgList[imgIdx].verify == 0"
                              :close-delay="10"
                            >
                              <el-image
                                style="
                                  width: 36px;
                                  height: 36px;
                                  position: absolute;
                                  right: -54px;
                                  top: 160px;
                                  cursor: pointer;
                                "
                                :src="
                                  require('../assets/img/textform/square2.png')
                                "
                                fit="contain"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </el-tooltip>
                            <el-tooltip
                              popper-class="tps"
                              class="item"
                              effect="dark"
                              :enterable="false"
                              content="审核失败"
                              placement="right"
                              v-else-if="imgList[imgIdx].verify == 2"
                              :close-delay="10"
                            >
                              <el-image
                                style="
                                  width: 36px;
                                  height: 36px;
                                  position: absolute;
                                  right: -54px;
                                  top: 160px;
                                  cursor: pointer;
                                "
                                :src="
                                  require('../assets/img/textform/square2.png')
                                "
                                fit="contain"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </el-tooltip>

                            <div
                              @click="carouselClick"
                              style="
                                position: absolute;
                                right: 10px;
                                top: 10px;
                                cursor: pointer;
                                justify-content: center;
                                align-items: center;
                                width: 40px;
                                height: 40px;
                                background: rgba(0, 0, 0, 0.5);
                                border-radius: 6px;
                                z-index: 9;
                              "
                              class="d-flex"
                            >
                              <el-image
                                style="width: 20px; height: 20px"
                                :src="
                                  require('../assets/img/textform/fullscreen.png')
                                "
                                fit="contain"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </div>

                            <el-image
                              style="
                                width: 50px;
                                height: 50px;
                                position: absolute;
                                left: 10px;
                                cursor: pointer;
                                z-index: 9;
                              "
                              v-if="imgList.length > 1"
                              :style="{
                                top:
                                  (main_height < main_width
                                    ? main_height
                                    : main_width) /
                                    2 -
                                  25 +
                                  'px',
                              }"
                              :src="require('../assets/img/textform/prev.png')"
                              fit="contain"
                              @click.stop="arrowClick('prev')"
                              class="arrowClickIcon"
                            >
                              <div slot="placeholder" class="image-slot"></div>
                            </el-image>
                            <el-image
                              style="
                                width: 50px;
                                height: 50px;
                                position: absolute;
                                right: 10px;
                                cursor: pointer;
                                z-index: 9;
                              "
                              v-if="imgList.length > 1"
                              :style="{
                                top:
                                  (main_height < main_width
                                    ? main_height
                                    : main_width) /
                                    2 -
                                  25 +
                                  'px',
                              }"
                              :src="require('../assets/img/textform/next.png')"
                              fit="contain"
                              @click.stop="arrowClick('next')"
                              class="arrowClickIcon"
                            >
                              <div slot="placeholder" class="image-slot"></div>
                            </el-image>
                          </div>

                          <div
                            class="img_list_cont d-flex"
                            style="
                              justify-content: center;
                              margin-top: 20px;
                              position: relative;
                            "
                          >
                            <template v-for="(item, idx) in imgList">
                              <el-image
                                @click="imgClick(idx)"
                                :fit="'contain'"
                                style="
                                  border-radius: 8px;
                                  height: 80px;
                                  width: 80px;
                                  margin-right: 20px;
                                "
                                :src="item.image"
                                v-if="item.image"
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                              <el-image
                                :src="
                                  require('../assets/img/textform/forbid.png')
                                "
                                fit="contain"
                                @click="imgClick(idx)"
                                style="
                                  border-radius: 8px;
                                  height: 80px;
                                  width: 80px;
                                  margin-right: 20px;
                                "
                                :fit="'cover'"
                                v-else
                              >
                                <div
                                  slot="placeholder"
                                  class="image-slot"
                                ></div>
                              </el-image>
                            </template>
                          </div>
                        </div>

                        <div
                          v-if="his_list.length == 0"
                          style="
                            color: gray;
                            text-align: center;
                            margin-top: 8px;
                            font-size: 16px;
                          "
                        >
                          暂无数据
                        </div>
                        <vue-loadmore
                          :on-refresh="onRefresh"
                          :on-loadmore="onLoad"
                          :finished="finished"
                          :finished-text="' '"
                          class="his_item_container"
                        >
                          <div
                            v-for="(item, i) in his_list"
                            :key="i"
                            class="his-item"
                            style="display: inline-block; position: relative"
                            @click="his_item_click(item.list)"
                            v-on:mouseover="handleMouseOver(i)"
                            v-on:mouseout="handleMouseOut(i)"
                          >
                            <el-image
                              class="deleteIcon"
                              style="
                                width: 16px;
                                height: 16px;
                                cursor: pointer;
                                position: absolute;
                                top: 8px;
                                right: 8px;
                                z-index: 11;
                              "
                              :src="
                                require('../assets/img/textform/delete.png')
                              "
                              fit="contain"
                              @click.stop="deleteHis(i)"
                            >
                              <div slot="placeholder" class="image-slot"></div>
                            </el-image>
                            <div class="top_model"></div>
                            <div
                              class="d-flex"
                              style="
                                flex-wrap: wrap;
                                justify-content: flex-start;
                              "
                            >
                              <template v-for="imgitem in item.list">
                                <el-image
                                  style="margin: 0; cursor: pointer"
                                  :src="imgitem.image"
                                  fit="contain"
                                  :class="{
                                    imgB1: item.list.length == 1,
                                    imgB2: item.list.length == 2,
                                    imgB3: item.list.length == 3,
                                    imgB4: item.list.length == 4,
                                  }"
                                  :fit="'cover'"
                                  v-if="imgitem.image"
                                >
                                  <div
                                    slot="placeholder"
                                    class="image-slot"
                                  ></div>
                                </el-image>
                                <el-image
                                  style="margin: 0; cursor: pointer"
                                  :src="
                                    require('../assets/img/textform/forbid.png')
                                  "
                                  fit="contain"
                                  :class="{
                                    imgB1: item.list.length == 1,
                                    imgB2: item.list.length == 2,
                                    imgB3: item.list.length == 3,
                                    imgB4: item.list.length == 4,
                                  }"
                                  :fit="'cover'"
                                  v-else
                                >
                                  <div
                                    slot="placeholder"
                                    class="image-slot"
                                  ></div>
                                </el-image>
                              </template>
                            </div>
                          </div>
                        </vue-loadmore>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="bd-content content d-flex" style="flex-direction: column;">
              <div style="flex: 1;" class="tool-main d-flex" ref="tool_main">
                <div style="flex: 1;flex-shrink: 0; position: relative;" class="left">
                  <el-upload
                    class="upload-demo"
                    :auto-upload="false"
                    drag
                    action=""
                    accept=".jpg, .png ,.jpeg"
                    :before-upload="checkLogin"
                    :on-change="getFile"
                    multiple
                    :show-file-list="false"
                    style="margin: 0 auto;background-color: rgb(17, 18, 37);"
                    :style="{ height:  ( main_height < main_width  ? main_height :  main_width   )   + 'px', width: ( main_height < main_width  ? main_height :  main_width   ) + 'px' }"  
                    v-if="!proofImage"  
                  >
                    <div style="width: 100%; height: 100%;position: relative;justify-content: center;align-items: center;" 
                    :style="{ height:  ( main_height < main_width  ? main_height :  main_width   )   + 'px', width: ( main_height < main_width  ? main_height :  main_width   ) + 'px' }" 
                    class="tool-main-cont d-flex" v-if="!proofImage" fit="contain" >
                      <div >
                        <el-image
                          style="width: 120px; height: 120px;cursor: pointer;"
                          :src="require('../assets/img/textform/pic.png')" fit="contain">
                          <div slot="placeholder" class="image-slot" ></div>
                        </el-image>
                        <div style="color: #CACAD4;">将图片拖至此处，或 <span style="color: #006FFF;">点击上传</span></div>
                      </div>
                    </div>
                  </el-upload>

                  <div style="margin: 0 auto;background-color: rgb(17, 18, 37);justify-content: center;position: relative;"
                    :style="{ height:  ( main_height < main_width  ? main_height :  main_width   )   + 'px', width: ( main_height < main_width  ? main_height :  main_width   ) + 'px' }"  
                    :class="{  'pen_type' : toolsType_pen    ,  'eraser_type' : toolsType_eraser  }"
                    v-show="proofImage" >
                    <canvas v-if="canvasWidth"  id="canvas1" :width="canvasWidth"  :height="canvasHeight" 
                    style="position:absolute;left: 50%;z-index: 99;top : 50%"  
                    :style="{ marginLeft : -canvasWidth/2 + 'px'  ,  marginTop : -canvasHeight/2 + 'px'  }"
                    ></canvas>
                    <canvas v-if="canvasWidth"  id="canvas2" :width="canvasWidth"  :height="canvasHeight" 
                    style="position:absolute;left: 50%;z-index: 100;top : 50%"  
                    :style="{ marginLeft : -canvasWidth/2 + 'px'  ,  marginTop : -canvasHeight/2 + 'px'  }"
                    ></canvas>

                    <div
                    class="d-flex"  @click.stop="deleteProofImage"
                    style="width: 40px;height: 40px;background: rgba(0,0,0,0.5);border-radius: 6px;position: absolute;right: 10px;top: 10px;z-index: 101;align-items: center;justify-content: center;">
                      <el-image
                        style="width: 20px; height: 20px;cursor: pointer;"
                        :src="require('../assets/img/textform/del.png')" fit="contain">
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </div>
                  </div>

                  <div   :style="{ width: ( main_height < main_width  ? main_height :  main_width   ) + 'px' }"  style="height: 80px;margin: 0 auto;" >
                    <div class="d-flex" style="justify-content: flex-end;margin-top: 6px;" v-if="proofImage">                      
                      <el-popover
                        placement="bottom"
                        width="170"
                        trigger="hover"
                        popper-class="imageToimage"
                      >
                        <div style="text-indent: 12px;">重绘涂抹的区域大小</div>
                        <el-slider v-model="toolslineWidth" :min="10" :max="100" :step="1"  style="width: 146px;"></el-slider>
                        <el-image
                          @click="changeTools('pen')"
                          slot="reference"
                          style="width: 36px; height: 36px;cursor: pointer;margin-right: 10px;"
                          :src="require('../assets/img/textform/pen_act.png')" fit="contain"
                          v-if="toolsType == 'pen'"
                          >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image
                          @click="changeTools('pen')"
                          slot="reference"
                          style="width: 36px; height: 36px;cursor: pointer;margin-right: 10px;"
                          :src="require('../assets/img/textform/pen.png')" fit="contain"
                          v-else
                          >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-popover>

                      <el-popover
                        placement="bottom"
                        width="170"
                        trigger="hover"
                        popper-class="imageToimage"
                      >
                        <div style="text-indent: 12px;">擦除涂抹的区域大小</div>
                        <el-slider v-model="toolsEraserWidth" :min="10" :max="100" :step="1"  style="width: 146px;"></el-slider>
                        <el-image
                          @click="changeTools('eraser')"
                          slot="reference"
                          style="width: 36px; height: 36px;cursor: pointer;"
                          :src="require('../assets/img/textform/eraser_act.png')" fit="contain"
                          v-if="toolsType == 'eraser'"
                          >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image
                          @click="changeTools('eraser')"
                          slot="reference"
                          style="width: 36px; height: 36px;cursor: pointer;"
                          :src="require('../assets/img/textform/eraser.png')" fit="contain"
                          v-else
                          >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-popover>
                  
                    </div>
                  </div>
                </div>

                <div style="flex: 1; flex-shrink: 0;">
                  <div class="tool-main-cont d-flex" v-if="imgList.length == 0"
                  :style="{ height:  ( main_height < main_width  ? main_height :  main_width   )   + 'px', width: ( main_height < main_width  ? main_height :  main_width   ) + 'px' }">

                    <div v-if="img_create_loading && curStatus == 0 && curObj.index != 0 && curObj.total != 0"
                      style="margin-top: 35px;">
                      任务排在 {{ curObj.index }}/{{ curObj.total }} 队列中，请耐心等待
                      <vue-typed-js
                        style="display: inline-block;min-width: 14px;"
                        :strings="[ '...' ]"
                        :loop="true"
                        :startDelay="0"
                        :typeSpeed="20"
                        :backSpeed="50"
                        :showCursor="false"
                      >
                        <span class="typing"></span>
                      </vue-typed-js>
                    </div>
                    <div v-if="img_create_loading && curStatus == 0 && curObj.index == 0 && curObj.total == 0"
                      style="margin-top: 35px;">
                      任务即将开始，请耐心等待
                      <vue-typed-js
                        style="display: inline-block;min-width: 14px;"
                        :strings="[ '...' ]"
                        :loop="true"
                        :startDelay="0"
                        :typeSpeed="20"
                        :backSpeed="50"
                        :showCursor="false"
                      >
                        <span class="typing"></span>
                      </vue-typed-js>
                    </div>
                    <el-progress type="circle" :percentage="curObj.progress - 0 ? (curObj.progress * 100).toFixed(0) - 0 : 1"
                      text-color="#fff" color="#006FFF"
                      v-if="img_create_loading && curStatus == 1 && curObj.progress"></el-progress>
                    <div v-if="img_create_loading && curStatus == 1 && curObj.progress && curObj.etaRelative >= 0"
                      style="margin-top: 35px;">
                      排队生成中，请稍候
                      <vue-typed-js
                        style="display: inline-block;min-width: 14px;"
                        :strings="[ '...' ]"
                        :loop="true"
                        :startDelay="0"
                        :typeSpeed="20"
                        :backSpeed="50"
                        :showCursor="false"
                      >
                        <span class="typing"></span>
                      </vue-typed-js>
                    </div>
                    <div v-else-if="img_create_loading && curStatus != 0" style="margin-top: 35px;">
                      处理中
                      <vue-typed-js
                        style="display: inline-block;min-width: 14px;"
                        :strings="[ '...' ]"
                        :loop="true"
                        :startDelay="0"
                        :typeSpeed="20"
                        :backSpeed="50"
                        :showCursor="false"
                      >
                        <span class="typing"></span>
                      </vue-typed-js>
                    </div>
                  </div>
                  <div v-if="imgList.length > 0" style="text-align: center;position: relative;" >
                    <div style="position: relative;margin: 0 auto !important;border-radius: 8px" 
                      :style="{ height: ( main_height < main_width  ? main_height :  main_width   )   + 'px', width: ( main_height < main_width  ? main_height :  main_width   ) + 'px' }"
                      class="exit_hover"
                      >

                      <el-carousel  :height="( main_height < main_width  ? main_height :  main_width   ) + 'px'"  arrow="never" :autoplay="false" :initial-index="imgIdx" indicator-position="none" ref="cardShow" class="images_" v-viewer="{movable: true , navbar : false  , toolbar : true  ,  title : false , fullscreen : false , rotatable : false , scalable : false  }">
                        <el-carousel-item v-for="(item , idx ) in imgList" :key="idx" >
                          <el-image :src="item.image" class="avatar" fit="contain" style="margin-left: 5px;"   :style="{  width: ( main_height < main_width  ? main_height :  main_width   ) + 'px'  , height: ( main_height < main_width  ? main_height :  main_width   ) + 'px'}" 
                          v-if="item.image"
                          >
                            <div slot="placeholder" class="image-slot"></div>
                          </el-image>
                          <el-image :fit="'contain'" 
                            :style="{  height: ( main_height < main_width  ? main_height :  main_width   ) + 'px' , width : ( main_height < main_width  ? main_height :  main_width   ) + 'px' }" style="margin: 0 auto !important;border-radius: 8px" 
                            :src="require('../assets/img/textform/forbid.png')"
                            v-else
                          >
                            <div slot="placeholder" class="image-slot"></div>
                          </el-image>
                        </el-carousel-item>
                      </el-carousel>
                    
                      <el-tooltip popper-class="tps" class="item" effect="dark" :enterable="false"
                  content="下载" placement="right" :close-delay="10"> 
                        <el-image
                          style="width: 36px; height: 36px;position: absolute;right: -54px;top: 10px;cursor: pointer;"
                          :src="require('../assets/img/textform/download.png')" fit="contain" @click="downloadImage">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-tooltip>

                      <el-tooltip popper-class="tps" class="item" effect="dark" :enterable="false"
                  content="分享" placement="right" :close-delay="10"> 
                        <el-image
                          style="width: 36px; height: 36px;position: absolute;right: -54px;top: 60px;cursor: pointer;"
                          :src="require('../assets/img/textform/share.png')" fit="contain" @click="shareImg">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-tooltip>

                      <el-tooltip popper-class="tps" class="item" effect="dark" :enterable="false"
                  content="发布到图生图局部重绘" placement="right" :close-delay="10"> 
                        <el-image
                          style="width: 36px; height: 36px;position: absolute;right: -54px;top: 110px;cursor: pointer;"
                          :src="require('../assets/img/textform/repaint.png')" fit="contain" @click="repainting_publish">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-tooltip>

                      <el-tooltip popper-class="tps" class="item" effect="dark" :enterable="false"
                  content="发布到广场" placement="right"  v-if="!imgList[imgIdx].published" :close-delay="10"> 
                        <el-image
                          style="width: 36px; height: 36px;position: absolute;right: -54px;top: 160px;cursor: pointer;"
                          :src="require('../assets/img/textform/square.png')" fit="contain" @click="painting_publish">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-tooltip>
                      <el-tooltip popper-class="tps" class="item" effect="dark" :enterable="false"
                    content="取消发布" placement="right" v-else-if="imgList[imgIdx].published" :close-delay="10"> 
                        <el-image
                          style="width: 36px; height: 36px;position: absolute;right: -54px;top: 160px;cursor: pointer;"
                          :src="require('../assets/img/textform/square2.png')" fit="contain" @click="painting_cancel">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </el-tooltip>

                      <div @click="carouselClick" style="position: absolute;right: 10px;top: 10px;cursor: pointer;justify-content: center;align-items: center;width: 40px;height: 40px;background: rgba(0,0,0,0.5);border-radius: 6px;z-index: 9;" class="d-flex">
                        <el-image style="width: 20px; height: 20px;" 
                        :src="require('../assets/img/textform/fullscreen.png')"
                        fit="contain" >
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </div>

                      <el-image style="width: 50px; height: 50px;position: absolute;left: 10px;cursor: pointer;z-index: 9;" v-if="imgList.length>1"
                      :style="{  top: ( (main_height < main_width  ? main_height :  main_width  ) /2-25) + 'px'  }"
                      :src="require('../assets/img/textform/prev.png')"
                      fit="contain" @click.stop="arrowClick('prev')"
                      class="arrowClickIcon"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      <el-image style="width: 50px; height: 50px;position: absolute;right: 10px;cursor: pointer;z-index: 9;"  v-if="imgList.length>1"
                      :style="{  top: ( (main_height < main_width  ? main_height :  main_width  ) /2-25) + 'px'  }"
                      :src="require('../assets/img/textform/next.png')"
                      fit="contain" @click.stop="arrowClick('next')"
                      class="arrowClickIcon"
                      >
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                    </div>

                    <div class="img_list_cont d-flex"
                      style="justify-content: center;margin-top: 20px;position: relative;">
                      <template v-for="(item, idx) in imgList">
                        <el-image @click="imgClick(idx)" :fit="'contain'"
                          style="border-radius: 8px;height: 80px;width: 80px;margin-right: 20px" :src="item.image"
                          v-if="item.image">
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                        <el-image :src="require('../assets/img/textform/forbid.png')" fit="contain" @click="imgClick(idx)"
                          style="border-radius: 8px;height: 80px;width: 80px;margin-right: 20px" :fit="'cover'" v-else>
                          <div slot="placeholder" class="image-slot"></div>
                        </el-image>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex"
                style="font-size: 16px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #828292;margin-bottom: 11px;align-items:flex-end;min-height:40px;position: relative;">
                <div style="width: 130px;">
                  <Prompt :mainheight="main_height" :promptArr="promptArr" @ClickPrompt="ClickPrompt"
                    :closePrompt="closePrompt" drawtype="image" :promptLanguage.sync="promptLanguage"
                    @ChangePrompt="ChangePrompt"
                    />
                </div>

                <div v-if="taskInterrogateFlag" class="getpromptBtn d-flex" style="align-items: center;justify-content: center;cursor: pointer;border: 1px solid #006FFF;opacity: 0.5;background: #0B0B1F;color: #006FFF;">
                  反向提取提示词
                </div>
                <div v-else  class="getpromptBtn d-flex" style="align-items: center;justify-content: center;cursor: pointer;" @click="taskInterrogate">
                  反向提取提示词
                </div>
    
    
                <div style="flex: 1;text-align: center;">
                  <el-button type="danger" style="background-color: #D74444;" v-if="img_create_loading"
                    @click="task_interrupt_click">取消任务</el-button>
                </div>
                <div style="width: 200px;text-align: right;" v-if="ac_data.points">{{ ac_data.points ? `剩余积分:
                  ${ac_data.points}` : "" }}</div>
              </div>

              <div class="d-flex bottom-cont" style="align-items: center;z-index: 100; ">
                <div style="flex:1;align-items: center;position: relative;" class="d-flex">
                  <el-input id="myTextarea" resize="none" type="textarea" :autosize="{ minRows: 1, maxRows: 3 }"
                    placeholder="请输入生成文案…" v-model="formVuex.prompt" :disabled="img_create_loading"
                    style="background-color: #222337;" @input.native="inputValue($event)"
                    @change.native="inputChangeValue($event)"  ref="text_input">
                  </el-input>
                  <SensitiveCont v-if="isSensitive" :text="stext" :sensitiveData="sensitiveData" @ListenSensitive="ListenSensitive"></SensitiveCont>

                  <div style=" background: #111225;padding: 1px 2px 2px;max-height: 31px;min-width: 112px;" class="radio_group">
                    <el-radio-group v-model="promptLanguage" size="mini" fill="#006FFF" class="language_label">
                      <el-radio-button label="中文"></el-radio-button>
                      <el-radio-button label="英文"></el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div @click="search"
                  style="width: 120px;height: 54px;margin-left: 4px;margin-right: 12px;cursor: pointer; background: linear-gradient(315deg, #006FFF 0%, #72E3F5 100%);border-radius: 8px;text-align: center;">
                  <div
                    style="font-size: 20px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;margin-top: 8px;">
                    生成
                  </div>
                  <div
                    style="font-size: 10px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #FFFFFF;transform:scale(0.8);margin-top: -2px;">
                    <span v-if="ac_data.vip">VIP生效中，无需积分</span>
                    <span v-else>本次消耗积分: {{ formVuex.batch_size * 2 }}</span>
                  </div>
                </div>
              </div>
            </div> -->
          </el-main>

          <!-- <el-aside width="300px" class="history">
            <el-tabs v-model="activeName" style="height: 100%;">
              <el-tab-pane label="工作区" name="1" style="height: 100%;">
                <span slot="label">
                  <div class="title t1"><span>工作区</span></div>
                </span>
                <div class="scroll-cont" v-bar
                  style="overflow-y: auto;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #828292 ;box-sizing: border-box;">
                  <imageImageForm ref="imageImageFormRef" :acData="ac_data"></imageImageForm>
                </div>
              </el-tab-pane>
              <el-tab-pane label="历史记录" name="2" style="height: 100%;">
                <span slot="label">
                  <div class="title t2"><span>历史记录</span></div>
                </span>
                <div class="scroll-cont"
                  style="scrollbar-width: none;overflow-y: auto;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #828292 ;box-sizing: border-box;">
                  <div v-if="his_list.length == 0"
                    style="color: gray;text-align: center;margin-top: 8px;font-size: 16px;">暂无数据</div>
                  <vue-loadmore :on-refresh="onRefresh" :on-loadmore="onLoad" :finished="finished" :finished-text="' '"
                    class="his_item_container">
                    <div v-for="(item, i) in his_list" :key="i" class="his-item "
                      style="display: inline-block;position: relative;" @click="his_item_click(item.list)"
                      v-on:mouseover="handleMouseOver(i)" v-on:mouseout="handleMouseOut(i)"
                      >

                      <el-image
                        class="deleteIcon"
                        style="width: 16px; height: 16px;cursor: pointer;position: absolute;top: 8px;right: 8px;z-index: 11;"
                        :src="require('../assets/img/textform/delete.png')" fit="contain" @click.stop="deleteHis(i)">
                        <div slot="placeholder" class="image-slot"></div>
                      </el-image>
                      <div class="top_model"></div>
                      <div class="d-flex" style="flex-wrap: wrap;justify-content: flex-start;">
                        <template v-for="imgitem in item.list">
                          <el-image style="margin: 0 ;cursor: pointer;" :src="imgitem.image" fit="contain"
                            :class="{ imgB1: item.list.length == 1, imgB2: item.list.length == 2, imgB3: item.list.length == 3, imgB4: item.list.length == 4 }"
                            :fit="'cover'" v-if="imgitem.image">
                            <div slot="placeholder" class="image-slot"></div>
                          </el-image>
                          <el-image style="margin: 0 ;cursor: pointer;"
                            :src="require('../assets/img/textform/forbid.png')" fit="contain"
                            :class="{ imgB1: item.list.length == 1, imgB2: item.list.length == 2, imgB3: item.list.length == 3, imgB4: item.list.length == 4 }"
                            :fit="'cover'" v-else>
                            <div slot="placeholder" class="image-slot"></div>
                          </el-image>
                        </template>
                      </div>
                    </div>
                  </vue-loadmore>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-aside> -->
        </el-container>
      </el-main>
    </el-container>

    <ShareCont
      :dialogShareVisible.sync="shareShow"
      :shareValue="shareValue"
      :shareImgMd5="shareImgMd5"
      :imgUrl="
        imgList && imgList[imgIdx] && imgList[imgIdx].image
          ? imgList[imgIdx].image
          : ''
      "
    >
    </ShareCont>
    <Carousel
      :dialogCarouselVisible.sync="carouselShow"
      :dialogImgArr.sync="dialogImgArr"
      :imgIdx.sync="imgIdx"
      v-if="carouselShow"
    ></Carousel>
    <GotoTask
      v-if="gotoTaskSHow"
      @closePopEmit="gotoTaskSHow = false"
    ></GotoTask>
    <LoginForm
      :dialogLoginVisible.sync="loginFormShow"
      v-if="loginFormShow"
    ></LoginForm>
    <NewRecharge
      :newRechargeShow.sync="newRechargeShow"
      v-if="newRechargeShow"
      @gotoRecharge="gotoRecharge"
    ></NewRecharge>
    <Status></Status>
  </el-container>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarLeft from "@/components/NavbarLeft.vue";
import SensitiveCont from "@/components/SensitiveCont";
import imageImageForm from "@/components/imageImageForm";

import ShareCont from "@/components/ShareCont";
import Prompt from "@/components/Prompt";
import Carousel from "@/components/Carousel";
import GotoTask from "@/components/gotoTask";
import NewRecharge from "@/components/NewRecharge";

import { chat_sensitiveKeywords_req } from "@/api/qa";
import {
  img_page_req,
  task_interrupt_req,
  task_status_req,
  task_running_req,
  task_undoTask_req,
  img_del,
  painting_removeByTid,
} from "@/api/taskImage";
import { add_task_req, task_interrogate_req } from "@/api/imageImage";
import { getSocketUrl, getToken, handleDownloadQrIMg } from "@/utils/bose";
import { user_account_req } from "@/api/user";
import {
  painting_page_req,
  painting_publish_req,
  painting_history_req,
  painting_cancel_req,
} from "@/api/personal";
import { growth_tasks_req, growth_publish_req } from "@/api/task";
import Status from "@/components/Status";
import LoginForm from "@/components/LoginForm";
import { painting_download_req } from "@/api/square";

export default {
  components: {
    Status,
    Navbar,
    NavbarLeft,
    imageImageForm,
    ShareCont,
    Prompt,
    Carousel,
    SensitiveCont,
    GotoTask,
    LoginForm,
    NewRecharge,
  },
  data() {
    return {
      wsUrl: getSocketUrl(),
      websock: null, //ws实例

      isMobile: false,
      bigScreen: false,
      recData: [],
      text: "",
      text2: "",
      loading: false,
      picselected: [], // Must be an array reference!
      show: false,
      bodyBgVariant: "dark",
      tools_show: false,

      progress_value: 0,
      img_create_loading: false,
      curTask: undefined,
      needSec: undefined,
      needSecStep: undefined,
      timer: null,
      imgList: [],
      imgIdx: 0,

      hiddenTime: undefined,
      // 下拉滚动相关
      pageNum: 1,
      pageSize: 20,
      his_list: [],
      finished: false,
      // 下拉滚动相关

      activeName: "1",

      ac_data: {}, //账户信息
      main_height: 450,
      main_width: 700,
      model_num: 9,

      curStatus: undefined,
      curObj: undefined,
      isQuery: undefined, //是否进行了查询
      shareShow: false, //分享模块是否展示
      shareValue: undefined,
      shareImgMd5: undefined,
      needUpdate: 1,
      closePrompt: 1,

      oldV: "",
      promptArr: [],

      proofImage: "",
      inpaint: false, //是否局部重绘
      inpaintStatus: false,

      carouselShow: false, //大图显示框
      dialogImgArr: [],

      isHover: false,
      hoverIdx: undefined,

      promptLanguage: "中文", //提示词语言
      penvalue: 50,
      canvasWidth: 0,
      canvasHeight: 0,
      toolsType: undefined,
      toolslineWidth: 50,
      toolsEraserWidth: 50,

      // 敏感词
      isSensitive: false,
      sensitiveData: [],
      stext: "",

      taskInterrogateFlag: false, //提取词状态
      gotoTaskSHow: false,
      loginFormShow: false,
      newRechargeShow: false, //新用户充值
      needRecharge: 0,
    };
  },
  async mounted() {
    if (this.tokenVuex) {
      let _this = this;
      this.img_page_get();
      await this.getUserAccountInfo(); //获取账户信息
      this.getTaskRunning();

      if (this.$route.params && this.$route.params.url) {
        this.convertImgToBase64(this.$route.params.url, (base64Img) => {
          var str = base64Img.substring(22);
          this.$nextTick(() => {
            if (str) _this.proofImage = str;
          });
        });
      }

      if (
        (!localStorage.getItem("gotoTaskSHow") ||
          localStorage.getItem("gotoTaskSHow") < 1) &&
        this.tokenVuex
      ) {
        localStorage.setItem("gotoTaskSHow", 1);
        this.gotoTaskSHow = true;
      }
    } else {
      // this.$toast.open({
      //   message: "请先登录噢",
      //   position: 'top',
      //   duration: 3000,
      //   queue: true,
      //   type: 'error',
      // })
      let _this = this;
      this.img_page_get();
      await this.getUserAccountInfo(); //获取账户信息
      this.getTaskRunning();

      if (this.$route.params && this.$route.params.url) {
        this.convertImgToBase64(this.$route.params.url, (base64Img) => {
          var str = base64Img.substring(22);
          this.$nextTick(() => {
            if (str) _this.proofImage = str;
          });
        });
      }
    }
    if (localStorage.getItem("imageParams")) {
      let params = JSON.parse(localStorage.getItem("imageParams"));
      console.log(params, "params");
      let data = {
        styleSeletedList: params.style.split(","),
        styleSeletedRadioList: params.style_ratio.split(","),
        featureSeletedRadioList: params.feature_ratio.split(","),
        feature: params.feature.split(","),
      };
      this.$refs.imageImageFormRef.setStyleData(data, params);
      this.proofImage = params.init_images[0];
      this.formVuex.prompt = params.prompt;
    }
    if (this.$refs.tool_main && this.$refs.tool_main.offsetHeight) {
      this.main_height = this.$refs.tool_main.offsetHeight - 300;
      this.main_width = this.$refs.tool_main.offsetWidth - 300;
      this.model_num = Math.floor((this.$refs.tool_main.offsetWidth - 25) / 84);
    } else {
      this.main_height = 400;
      this.main_width = 400;
      this.model_num = 9;
    }

    if (!window.matchMedia("(max-width:991px)").matches) {
      this.bigScreen = true;
    } else {
      this.bigScreen = false;
    }
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    this.recData = this.recData1;

    // rePaintUrl
    if (this.$route.params && this.$route.params.rePaintUrl) {
      this.convertImgToBase64(this.$route.params.rePaintUrl, (base64Img) => {
        this.proofImage = base64Img.slice(22);
      });
    }

    // _czc.push([
    //   "_trackEvent",
    //   "imageimage",
    //   "enter",
    //   localStorage.getItem("cc") ? localStorage.getItem("cc") : "none",
    //   "",
    //   "",
    // ]);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (localStorage.getItem("taskIds")) {
      task_status_req(localStorage.getItem("taskIds")).then((res) => {
        if (res.data.status >= 2 && localStorage.getItem("imageParams")) {
          localStorage.removeItem("taskIds");
          localStorage.removeItem("imageParams");
        }
      });
    }
    // this.task_interrupt_click();
  },
  destroyed() {
    //离开路由之后断开websocket连接
    // this.websock.close();
  },
  computed: {
    formVuex: {
      get() {
        // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
        return this.$store.state.imageImage.form;
      },
      set(newVal) {
        this.formVuex = newVal;
      },
    },
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
    toolsType_pen() {
      return this.toolsType == "pen";
    },
    toolsType_eraser() {
      return this.toolsType == "eraser";
    },
  },
  methods: {
    btoaFunc(val) {
      return window.btoa(val);
    },
    // change(){
    //   this.$store.commit('exchange')
    // }
    deleteHis(i) {
      if (this.img_create_loading) {
        return;
      }
      let taskId = this.his_list[i].taskId;

      this.$confirm("", "删除此条记录，您的作品也将一并删除，是否删除?", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        center: true,
        customClass: "_message_box2",
      })
        .then(({ value }) => {
          painting_removeByTid(taskId).then((res) => {
            this.$toast.open({
              message: "已删除",
              position: "top",
              duration: 3000,
              type: "success",
            });

            try {
              if (
                this.his_list[i].list[0].md5 &&
                this.imgList[0].md5 &&
                this.his_list[i].list[0].md5 == this.imgList[0].md5
              ) {
                this.imgList = [];
              }
            } catch (error) {
              console.error(error);
            }
            this.his_list.splice(i, 1);
          });
        })
        .catch(() => {
          // this.$toast.open({
          //     message: '删除失败，请稍后再试',
          //     position: 'top',
          //     duration: 1000,
          //     type: 'error',
          //   });
        });
    },
    taskInterrogate() {
      if (this.img_create_loading) {
        return;
      }
      if (!this.proofImage) {
        this.$toast.open({
          message: "请先上传图片哦",
          position: "top",
          duration: 3000,
          type: "error",
        });
        return;
      }
      this.$toast.open({
        message: "开始提取提示词",
        position: "top",
        duration: 2000,
        type: "info",
      });
      this.taskInterrogateFlag = true;

      task_interrogate_req({
        image: this.proofImage,
      })
        .then((res) => {
          this.$toast.open({
            message: "已获取提示词",
            position: "top",
            duration: 3000,
            type: "success",
          });
          if (this.formVuex.prompt) {
            this.formVuex.prompt = this.formVuex.prompt + "，" + res.data;
          } else {
            this.formVuex.prompt = res.data;
          }
        })
        .catch()
        .finally(() => {
          this.taskInterrogateFlag = false;
        });
    },
    testSensitive(text) {
      return new Promise((myResolve) => {
        chat_sensitiveKeywords_req({
          text: text,
        }).then((res) => {
          myResolve(res.data);
        });
      });
    },
    ListenSensitive() {
      this.isSensitive = false;
      this.sensitiveData = [];
      this.$nextTick(() => {
        this.$refs.text_input.focus();
      });
    },
    async search() {
      if (this.img_create_loading) {
        return;
      }

      if (!this.tokenVuex) {
        this.loginFormShow = true;
        return;
      }

      // 有敏感词就停止
      if (this.$store.state.imageImage.form.prompt) {
        await this.testSensitive(this.$store.state.imageImage.form.prompt).then(
          (_data) => {
            if (_data.length > 0) {
              this.sensitiveData = _data;
              this.stext = this.$store.state.imageImage.form.prompt;
              this.isSensitive = true;
            }
          }
        );
        if (this.isSensitive == true) {
          return;
        }
      }

      if (this.inpaint) {
        await this.drawMask().then((res) => {
          if (res) {
            if (this.inpaintStatus) {
              this.$store.state.imageImage.form.mask = res.slice(22);
            }
          } else {
            this.$store.state.imageImage.form.mask = undefined;
          }
        });
      }
      this.inpaint = false;
      this.inpaintStatus = false;
      if (!this.proofImage) {
        this.$toast.open({
          message: "请先选择图片哦",
          position: "top",
          duration: 3000,
          type: "error",
        });
        return;
      } else {
        await this.drawproofImage().then((res) => {
          this.$store.state.imageImage.form.init_images = [res.slice(22)];
        });
      }

      let obj = this.$refs.imageImageFormRef.getStyleData();
      this.$store.state.imageImage.form.style = obj.styleSeletedList.join(",");
      this.$store.state.imageImage.form.style_ratio =
        obj.styleSeletedRadioList.join(",");

      let obj2 = this.$refs.imageImageFormRef.getFeatureData();
      this.$store.state.imageImage.form.feature =
        obj2.featureSeletedList.join(",");
      this.$store.state.imageImage.form.feature_ratio =
        obj2.featureSeletedRadioList.join(",");
      let imageParams = {
        ...this.$store.state.imageImage.form,
      };
      localStorage.setItem("imageParams", JSON.stringify(imageParams));
      // this.$store.state.imageImage.form.init_images = [ this.proofImage ]
      this.closePrompt++;
      this.imgIdx = 0;
      this.imgList = [];
      this.img_create_loading = true;
      let params = JSON.parse(
        JSON.stringify(this.$store.state.imageImage.form)
      );
      // params.enable_hr = undefined ;
      // params.hr_scale = undefined ;
      // params.hr_upscaler = undefined ;
      // params.resize_mode = undefined;
      // this.$store.state.imageImage.form.mask = undefined ;
      await add_task_req(params).then((res) => {
        const { data, success } = res;
        if (data && success) {
          this.curTask = data;
          localStorage.setItem("taskId", data);
          localStorage.setItem("taskIds", data);
          localStorage.setItem("link", "/image-image");
          if (this.timer) clearInterval(this.timer);
          if (this.$store.state.imageImage.form.from) {
            this.hasFrom = true;
          }
          this.startTaskStatus();
        } else {
          this.curTask = undefined;
          this.img_create_loading = false;
          this.progress_value = 0;
          this.needSec = undefined;
          this.needSecStep = undefined;
          this.imgList = [];
        }
      });
    },
    saveFormVuex() {
      this.$store.commit("changeImageImageForm", this.formVuex);
      // changeTextImageForm
      this.tools_show = false;
    },
    //下载图片
    handleDownloadQrIMgClick() {
      if (this.imgList[this.imgIdx] && this.imgList[this.imgIdx].image) {
        handleDownloadQrIMg(this.imgList[this.imgIdx].image);
      }
    },

    // 历史记录相关 //
    onRefresh(done) {
      this.his_list = [];
      this.pageNum = 1;
      this.finished = false;
      this.img_page_get();
      done();
    },
    onLoad(done) {
      this.img_page_get();
      done();
    },
    // 获取历史记录
    img_page_get(params) {
      if (!this.tokenVuex) {
        return;
      }
      painting_history_req({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        category: 2,
        orderType: 1,
      }).then((res) => {
        if (res.success) {
          if (params && params.refresh == true) this.his_list = [];
          if (this.pageNum == 1 && this.$route.query?.type === "echo") {
            this.his_item_click(res.data.records[0].list);
          }
          this.his_list = this.his_list.concat(res.data.records);
          if (this.pageNum >= res.data.pages) {
            this.finished = true;
            return;
          }
          this.pageNum++;
        } else {
          this.his_list = [];
          this.pageNum = 1;
        }
      });
    },
    his_item_click(list) {
      this.imgList = list;
      this.imgIdx = 0;
      document.getElementById("bd_content_img_img").scrollIntoView();
    },
    // 历史记录相关 //
    downloadImage() {
      if (this.imgList[this.imgIdx].image === null) {
        this.$toast.open({
          message: "违规图片无法下载",
          position: "top",
          duration: 3000,
          type: "default",
        });
        return;
      }

      painting_download_req({
        imgMd5: this.imgList[this.imgIdx].md5,
        isMask: false,
      }).then((res) => {
        const image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.src = res.data;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, image.width, image.height);
          const url = canvas.toDataURL("image/png");
          const a = document.createElement("a");
          a.href = url;
          a.download = "image.png";
          a.click();
        };
      });

      return;

      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.src = this.imgList[this.imgIdx].image;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        a.download = "image.png";
        a.click();
      };
    },
    shareImg() {
      if (this.imgList[this.imgIdx].image === null) {
        this.$toast.open({
          message: "违规图片无法分享",
          position: "top",
          duration: 3000,
          type: "default",
        });
        return;
      }
      this.$prompt("", "分享图展示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "输入标题会更受欢迎哦（可选）",
        inputErrorMessage: "标题最多20字哦",
        inputPattern: /^(a-z|A-Z|0-9)*[^$%^&*;:,<>?()\""\']{0,20}$/,
        center: true,
        customClass: "_message_box",
      })
        .then(({ value }) => {
          this.shareValue = value ? value : "";
          this.shareImgMd5 = this.imgList[this.imgIdx].md5;
          this.shareShow = true;
          growth_publish_req({ type: 4 }).then(() => {
            growth_tasks_req({ type: 4 }).then((res1) => {
              if (res1.data[0].total >= res1.data[0].count) {
                setTimeout(() => {
                  this.$toast.open({
                    message: "分享成功，2积分已到账",
                    position: "top",
                    duration: 3000,
                    type: "success",
                  });
                }, 1000);
              }
            });
          });
        })
        .catch(() => {});

      //this.shareShow = true ;
    },
    painting_publish() {
      if (
        this.imgList[this.imgIdx].verify == 0 ||
        this.imgList[this.imgIdx].verify == 2
      ) {
        return;
      }
      // this.imgMd5 = this.imgList[this.imgIdx].imgMd5 ;
      // this.imgIndex = this.imgIdx ;
      if (this.imgList[this.imgIdx].verify == 1) {
        this.$toast.open({
          message: "该作品已发布!",
          position: "top",
          duration: 3000,
          type: "error",
        });
      } else {
        this.$confirm("", "是否发布这个作品?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          customClass: "_message_box",
        }).then(({ value }) => {
          console.log(this.imgList);
          //发布
          painting_publish_req({
            imgMd5: this.imgList[this.imgIdx].md5,
          }).then((res) => {
            this.imgList[this.imgIdx].verify = 0;
            if (res.success) {
              this.$toast.open({
                message: "已发布",
                position: "top",
                duration: 3000,
                type: "success",
              });

              growth_tasks_req({ type: 2 }).then((res1) => {
                if (res1.data[0].total == res1.data[0].count) {
                  setTimeout(() => {
                    this.$toast.open({
                      message: "发布成功，2积分已到账",
                      position: "top",
                      duration: 3000,
                      type: "success",
                    });
                  }, 1000);
                }
              });
            }
          });
        });
      }
    },
    painting_cancel() {
      if (!this.imgList[this.imgIdx].published) {
        this.$toast.open({
          message: "该作品未发布!",
          position: "top",
          duration: 3000,
          type: "error",
        });
      } else {
        this.$confirm("", "是否取消发布这个作品?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
          customClass: "_message_box",
        }).then(({ value }) => {
          console.log(this.imgList);
          //发布
          painting_cancel_req({
            imgMd5: this.imgList[this.imgIdx].md5,
          }).then((res) => {
            this.imgList[this.imgIdx].published = false;
            if (res.success) {
              this.$toast.open({
                message: "已取消",
                position: "top",
                duration: 3000,
                type: "success",
              });
            }
          });
        });
      }
    },
    repainting_publish() {
      if (!this.imgList[this.imgIdx].image) {
        return;
      }

      if (document.getElementById("canvas2")) {
        var canvas2 = document.getElementById("canvas2");
        var cs2Ctx = canvas2.getContext("2d");
        cs2Ctx.clearRect(0, 0, this.main_width, this.main_height);
      }

      this.$store.state.imageImage.form.mask = undefined;
      this.proofImage = undefined;
      this.convertImgToBase64(this.imgList[this.imgIdx].image, (base64Img) => {
        this.proofImage = base64Img.slice(22);
      });
    },
    async getUserAccountInfo() {
      const { data, success } = await user_account_req();
      if (success) {
        this.ac_data = data;

        setTimeout(() => {
          if (this.$route.name != "imageToImage") return;
          var todaysDate = new Date();
          if (localStorage.getItem("hasRecharge")) {
          } else {
            if (localStorage.getItem("rechargeShowDate")) {
              //如果有
              if (
                localStorage.getItem("rechargeShowDate") ==
                todaysDate.setHours(0, 0, 0, 0)
              ) {
                //弹过了
              } else {
                localStorage.setItem(
                  "rechargeShowDate",
                  todaysDate.setHours(0, 0, 0, 0)
                );
                this.newRechargeShow = true;
              }
            } else {
              localStorage.setItem(
                "rechargeShowDate",
                todaysDate.setHours(0, 0, 0, 0)
              );
              this.newRechargeShow = true;
            }
          }
        }, 1000);
      }
    },
    async task_interrupt_click() {
      if (this.curTask) {
        if (this.timer) clearInterval(this.timer);
        const { success, data } = await task_interrupt_req(this.curTask);
        if (success && data) {
          this.curTask = undefined;
          this.progress_value = 0;
          this.needSec = undefined;
          this.needSecStep = undefined;
          this.img_create_loading = false;
          this.imgList = [];
          this.$toast.open({
            message: "已取消",
            position: "top",
            duration: 3000,
            type: "success",
          });
        }
      }
    },
    imgClick(idx) {
      this.imgIdx = idx;
      this.$refs.cardShow.setActiveItem(idx);
    },

    startTaskStatus() {
      this.timer = setInterval(() => {
        if (this.isQuery == true) return;
        this.isQuery = true;
        task_status_req(this.curTask)
          .then((statusres) => {
            this.curStatus = statusres.data.status;
            if (this.curStatus == 0) {
              this.curObj = statusres.data.obj;
              // console.log(statusres)
            } else if (this.curStatus == 1) {
              // console.log(statusres)
              this.curObj = statusres.data.obj;
            } else if (this.curStatus == 2) {
              clearInterval(this.timer);
              this.curTask = undefined;
              this.img_create_loading = false;
              this.curObj = statusres.data.obj;
              this.imgList = statusres.data.obj.list;
              this.pageNum = 1;
              this.finished = false;
              this.his_list = [];
              this.img_page_get({
                refresh: true,
              });

              if (this.hasFrom) {
                growth_tasks_req({ type: 5 }).then((res1) => {
                  if (res1.data[0].total >= res1.data[0].count) {
                    setTimeout(() => {
                      this.$toast.open({
                        message: "应用成功，2积分已到账",
                        position: "top",
                        duration: 3000,
                        type: "success",
                      });
                    }, 1000);
                  }
                });
              }
            } else if (this.curStatus == 3) {
              clearInterval(this.timer);
              this.curTask = undefined;
              this.img_create_loading = false;
              this.curObj = undefined;
              this.imgList = [];
              this.curStatus = undefined;
              this.$toast.open({
                message: statusres.data.obj,
                position: "top",
                duration: 3000,
                type: "error",
              });
            } else if (this.curStatus == 5) {
              clearInterval(this.timer);
              this.curTask = undefined;
              this.img_create_loading = false;
              this.curObj = undefined;
              this.imgList = [];
              this.curStatus = undefined;
              this.$toast.open({
                message: statusres.data.obj,
                position: "top",
                duration: 3000,
                type: "success",
              });
            }
          })
          .catch((err) => {
            clearInterval(this.timer);
          })
          .finally((res) => {
            this.isQuery = false;
            this.getUserAccountInfo(); //获取账户信息
          });
      }, 1000);
    },
    async getTaskRunning() {
      const { success, data } = await task_undoTask_req({ category: 1 });
      if (success && data && data.taskId) {
        this.imgIdx = 0;
        this.imgList = [];
        this.img_create_loading = true;
        //说明有存在的任务
        this.curTask = data.taskId;
        if (this.timer) clearInterval(this.timer);
        this.startTaskStatus();
      }
    },
    handleSelectionChange(e) {
      const textarea = document.getElementById("myTextarea");
      const cursorPosition = textarea.selectionStart;
    },
    // 获取光标所在位置的index
    inputValue(event, value) {
      const arr =
        this.formVuex.prompt && this.formVuex.prompt.length > 0
          ? this.formVuex.prompt.split("，")
          : [];
      const result = Array.from(new Set(arr));
      this.promptArr = result;
    },
    inputChangeValue(event) {
      const arr =
        this.formVuex.prompt && this.formVuex.prompt.length > 0
          ? this.formVuex.prompt.split("，")
          : [];
      const result = Array.from(new Set(arr));
      this.promptArr = result;
    },
    ClickPrompt(val, flag) {
      // _arr.map
      if (flag) {
        //追加
        if (this.formVuex.prompt) {
          this.formVuex.prompt = this.formVuex.prompt + "，" + val;
        } else {
          this.formVuex.prompt = val;
        }
      } else {
        let _arr = this.formVuex.prompt.split("，"); //输入框的数据
        _arr = _arr.filter((item) => item != val);
        this.formVuex.prompt = _arr.join("，");
      }
    },

    ChangePrompt(val) {
      this.formVuex.prompt = val.join("，");
    },
    getFile(file, fileList, scope) {
      if (!this.tokenVuex) {
        this.loginFormShow = true;
        return;
      }
      let imgSize = Number(file.size / 1024 / 1024);
      if (imgSize > 5) {
        this.$toast.open({
          message: "图片最大5MB哦，请重试",
          position: "top",
          duration: 3000,
          type: "error",
        });
        return;
      }

      if (fileList && fileList.length >= 2) {
        fileList.shift();
      }
      this.proofImage = undefined;
      this.getBase64(file.raw).then((res) => {
        const params = res.split(",");
        if (params.length > 0) {
          this.proofImage = params[1];
          this.$store.state.imageImage.form.mask = undefined;

          this.taskInterrogate();
        }
      });
    },
    // 获取图片转base64
    getBase64(file) {
      let _this = this;
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          imgResult = reader.result;

          const img = e.target.result;
          const image = new Image();
          image.src = img;
          image.onload = (_) => {
            let width = image.width;
            let height = image.height;

            if (width >= 2000 || height >= 2000) {
              if (width >= height) {
                let bili = width / height;
                width = 2000;
                height = Math.floor(2000 / bili);
              } else {
                let bili = height / width;
                height = 2000;
                width = Math.floor(2000 / bili);
              }
              _this.formVuex.width = width;
              _this.formVuex.height = height;
            } else {
              _this.formVuex.width = width;
              _this.formVuex.height = height;
            }
          };
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
    },
    carouselClick() {
      // this.carouselShow = true ;
      // this.dialogImgArr = this.imgList
      const viewer = this.$el.querySelector(".images_").$viewer;
      //调用show方法进行显示预览图
      viewer.show();
    },
    arrowClick(val) {
      if (val === "next") {
        if (this.imgIdx >= this.imgList.length - 1) {
          this.imgIdx = 0;
        } else {
          this.imgIdx++;
        }
        this.$refs.cardShow.next();
      } else {
        if (this.imgIdx == 0) {
          this.imgIdx = this.imgList.length - 1;
        } else {
          this.imgIdx--;
        }
        this.$refs.cardShow.prev();
      }
    },
    handleMouseOver(index) {
      this.isHover = true;
      this.hoverIdx = index;
    },
    handleMouseOut() {
      this.isHover = false;
      this.hoverIdx = undefined;
    },
    transPoint() {
      if (
        Math.round((this.formVuex.width / this.formVuex.height) * 100) /
          100.0 ==
        1
      ) {
        // 1 :1
        if (this.formVuex.width == 512) {
          return 2;
        } else {
          return 4;
        }
      } else if (
        Math.round((this.formVuex.width / this.formVuex.height) * 100) /
          100.0 ==
        0.5
      ) {
        if (this.formVuex.width == 512) {
          return 3;
        } else {
          return 4;
        }
      } else if (
        Math.round((this.formVuex.width / this.formVuex.height) * 100) /
          100.0 ==
        1.33
      ) {
        if (this.formVuex.width == 1024) {
          return 4;
        } else {
          return 6;
        }
      } else if (
        Math.round((this.formVuex.width / this.formVuex.height) * 100) /
          100.0 ==
        0.75
      ) {
        if (this.formVuex.width == 768) {
          return 4;
        } else {
          return 6;
        }
      } else if (
        Math.round((this.formVuex.width / this.formVuex.height) * 100) /
          100.0 ==
        1.78
      ) {
        if (this.formVuex.width == 1024) {
          return 4;
        } else {
          return 7;
        }
      } else if (
        Math.round((this.formVuex.width / this.formVuex.height) * 100) /
          100.0 ==
        0.56
      ) {
        if (this.formVuex.width == 576) {
          return 4;
        } else {
          return 7;
        }
      }

      // console.log( (Math.round( this.formVuex.width / this.formVuex.height * 100) / 100.00 ) )

      return 3;
    },
    changeTools(type) {
      if (type == this.toolsType) {
        // this.toolsType = undefined
      } else {
        this.toolsType = type;
      }
    },
    deleteProofImage() {
      this.proofImage = undefined;
      this.inpaint = false;
      this.inpaintStatus = false;
      this.$store.state.imageImage.form.mask = undefined;
    },
    drawMask(_canvas, _image) {
      let _this = this;
      var status = false;

      function getImageOriginSize(src) {
        return new Promise((resolve) => {
          const image = new Image();
          image.src = src;
          image.onload = () => {
            resolve({
              width: image.naturalWidth,
              height: image.naturalHeight,
            });
          };
        });
      }

      function scaleImage(src, width, height) {
        return new Promise((resolve) => {
          const image = new Image();
          image.src = src;
          image.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, width, height);
            resolve(canvas.toDataURL());
          };
        });
      }

      return new Promise(async (resolve) => {
        var canvas = document.getElementById("canvas2");
        var ctx = canvas.getContext("2d");
        const imageData = ctx.getImageData(
          0,
          0,
          canvas.clientWidth,
          canvas.clientHeight
        );
        const imageDataContent = imageData.data;

        // 修改图像数据中的像素颜色
        for (let i = 0; i < imageDataContent.length; i += 4) {
          // 判断透明度是否小于阈值
          if (imageDataContent[i + 3] < 128) {
            // 将透明部分设置为黑色
            imageDataContent[i] = 0;
            imageDataContent[i + 1] = 0;
            imageDataContent[i + 2] = 0;
            imageDataContent[i + 3] = 255;
          } else {
            _this.inpaintStatus = true;
            // 将线条部分设置为白色
            imageDataContent[i] = 255;
            imageDataContent[i + 1] = 255;
            imageDataContent[i + 2] = 255;
            imageDataContent[i + 3] = 255;
          }
        }
        // 将修改后的图像数据导出为图片格式
        const exportCanvas = document.createElement("canvas");
        exportCanvas.width = canvas.clientWidth;
        exportCanvas.height = canvas.clientHeight;
        const exportCtx = exportCanvas.getContext("2d");
        exportCtx.putImageData(imageData, 0, 0);
        // mask放大到和原图一致
        // const size = await getImageOriginSize(_image);
        const finalMask = await scaleImage(
          exportCanvas.toDataURL(),
          canvas.clientWidth,
          canvas.clientHeight
        );

        resolve(finalMask, status);
      });
    },
    drawproofImage() {
      function scaleImage(src, width, height) {
        return new Promise((resolve) => {
          const image = new Image();
          image.src = src;
          image.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, width, height);
            resolve(canvas.toDataURL());
          };
        });
      }
      function getNaturalWidth(src) {
        var image = new Image();
        image.src = src;
        var naturalWidth = image.width;
        var naturalHeight = image.height;
        return { naturalWidth, naturalHeight };
      }

      return new Promise(async (resolve) => {
        var canvas = document.getElementById("canvas1");
        var ctx = canvas.getContext("2d");
        const imageData = ctx.getImageData(
          0,
          0,
          canvas.clientWidth,
          canvas.clientHeight
        );
        const imageDataContent = imageData.data;

        // 将修改后的图像数据导出为图片格式
        const exportCanvas = document.createElement("canvas");
        exportCanvas.width = canvas.clientWidth;
        exportCanvas.height = canvas.clientHeight;
        const exportCtx = exportCanvas.getContext("2d");
        exportCtx.putImageData(imageData, 0, 0);

        // mask放大到和原图一致
        // const size = await getImageOriginSize(_image);
        // const finalMask = await scaleImage(exportCanvas.toDataURL(), canvas.clientWidth , canvas.clientHeight);
        const finalMask = await scaleImage(
          exportCanvas.toDataURL(),
          canvas.clientWidth,
          canvas.clientHeight
        );
        resolve(finalMask);
      });
    },
    checkLogin() {
      return false;
    },
    gotoRecharge() {
      this.newRechargeShow = false;
      this.needRecharge++;
    },
  },
  watch: {
    tokenVuex(newQuestion, oldQuestion) {
      // console.log( newQuestion  )
      if (!newQuestion) {
        this.$router.replace({
          name: "home", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
          params: {
            unlogin: true,
          },
        });
      } else {
        let _this = this;
        this.img_page_get();
        this.getUserAccountInfo(); //获取账户信息
        this.getTaskRunning();
      }
    },
    needUpdate(newQuestion) {
      this.getUserAccountInfo(); //获取账户信息
    },
    promptLanguage(newVal) {
      const arr =
        this.formVuex.prompt && this.formVuex.prompt.length > 0
          ? this.formVuex.prompt.split("，")
          : [];
      const result = Array.from(new Set(arr));
      this.promptArr = result;
    },
    activeName(newVal) {
      this.imgList = [];
    },
    proofImage(newQuestion, oldQuestion) {
      let _this = this;
      var image = new Image();
      image.src = "data:image/png;base64," + newQuestion;
      let size =
        this.main_height < this.main_width ? this.main_height : this.main_width;
      image.onload = function () {
        if (this.width >= this.height) {
          // 宽 > 高
          let bili = (this.width / this.height).toFixed(2); //1.5
          _this.canvasWidth = size;
          _this.canvasHeight = (size / bili).toFixed(0);
        } else {
          let bili = (this.height / this.width).toFixed(2); //1.5
          _this.canvasHeight = size;
          _this.canvasWidth = (size / bili).toFixed(0);
        }

        _this.$nextTick(() => {
          var flag = false; // 记录鼠标按下和抬起事件，标记工具是否开始工作
          var canvas1 = document.getElementById("canvas1");
          var canvas2 = document.getElementById("canvas2");
          var ctx1 = canvas1.getContext("2d");
          var ctx2 = canvas2.getContext("2d");
          if (this.width >= this.height) {
            // 宽 > 高
            let bili = (this.width / this.height).toFixed(2); //1.5
            ctx1.drawImage(image, 0, 0, _this.canvasWidth, _this.canvasHeight);
            // ctx2.drawImage(image, 0, 0 , _this.canvasWidth , _this.canvasHeight  );
          } else {
            // 高 > 宽
            let bili = (this.height / this.width).toFixed(2); //1.5
            // ctx2.drawImage(image, (size - (size/bili).toFixed(0)) / 2 , 0 , (size/bili).toFixed(0)  , size  );
            ctx1.drawImage(image, 0, 0, _this.canvasWidth, _this.canvasHeight);
            // ctx2.drawImage( image ,  0, 0 ,  _this.canvasWidth , _this.canvasHeight );
          }

          var cs2Ctx = canvas2.getContext("2d");
          var cs1Ctx = canvas1.getContext("2d");
          // onmousedown事件
          canvas2.onmousedown = function (eva) {
            var eva = eva || window.event;
            cs2Ctx.lineCap = "round";
            cs2Ctx.lineJoin = "round";
            var x = eva.offsetX;
            var y = eva.offsetY;
            cs2Ctx.beginPath();
            cs2Ctx.moveTo(x, y);
            flag = true;
            cs2Ctx.lineWidth = _this.toolslineWidth;
            cs2Ctx.strokeStyle = "#006FFF";

            // "#006FFF";
          };
          // onmousemove事件
          canvas2.onmousemove = function (eva) {
            if (flag) {
              // if(isEraser){
              if (_this.toolsType == "eraser") {
                var w = _this.toolsEraserWidth;
                // noinspection JSAnnotator
                let pxs = cs1Ctx.getImageData(
                  eva.offsetX - w / 2,
                  eva.offsetY - w / 2,
                  w,
                  w
                );
                cs2Ctx.clearRect(
                  eva.offsetX - w / 2,
                  eva.offsetY - w / 2,
                  w,
                  w
                );
                // cs2Ctx.putImageData(pxs, eva.offsetX-w/2, eva.offsetY-w/2);
              } else if (_this.toolsType == "pen") {
                var eva = eva || window.event;
                var x = eva.offsetX;
                var y = eva.offsetY;
                cs2Ctx.lineTo(x, y);
                cs2Ctx.stroke();
                _this.inpaint = true;
              }
            }
          };
          // onmouseup事件
          canvas2.onmouseup = function () {
            flag = false;
            cs2Ctx.closePath();
          };
          // onmouseleave事件
          canvas2.onmouseleave = function () {
            flag = false;
            cs2Ctx.closePath();
          };
        });
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.generate {
  width: 120px;
  height: 54px;
  margin-left: 4px;
  margin-right: 12px;
  cursor: pointer;
  background: linear-gradient(315deg, #006fff 0%, #72e3f5 100%);
  border-radius: 8px;
  text-align: center;
}
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
}

::v-deep .el-tabs__item {
  color: #cacad4;
  font-weight: 400;
  padding: 0;
}

::v-deep .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #111225;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

/*修改.el-progress背景色*/
::v-deep .el-progress-circle__track {
  stroke: #38394b;
}

::v-deep .modal-class {
  position: relative;
  min-height: 200px;
}

::v-deep .modal-class .chevron-left {
  position: absolute;
  left: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
}

::v-deep .modal-class .chevron-right {
  position: absolute;
  right: 3px;
  top: 45%;
  font-size: 30px;
  color: #fff;
  z-index: 999;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #111225;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
  background: #222337;
}

::v-deep .el-textarea__inner {
  background: #222337;
  border: none;
  color: #fff;

  &::placeholder {
    color: #49495a;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: #49495a;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: #49495a;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: #49495a;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: #49495a;
  }
}
::v-deep .el-slider__bar {
  background-color: #006fff;
}

.container-fluid {
  // background-color: #f5f6f9;
  padding-left: 5px;
  padding-right: 5px;
  height: calc(100%);
}

::v-deep .main_cont {
  height: calc(100vh - 66px);

  .el-upload-dragger {
    width: 100%;
    height: 100%;
    border: none;
    background-color: #0b0b1f !important;
  }

  .upload-file .el-upload-list .el-upload-list__item:hover .el-icon-close {
    display: none;
  }
}

.content {
  box-sizing: border-box;
  // background-color: #f5f6f9;
  height: 100%;

  .toolbox {
    text-align: left;
    padding: 12px;
    box-sizing: border-box;
    font-size: 14px;
    overflow: hidden;
    height: 100%;
    padding-right: 20px;
    /* 防止滚动条遮挡内容 */

    .toolbox_cont {
    }

    .title {
      font-weight: 700;
      color: #333;
      padding-bottom: 8px;
      border-bottom: 2px solid #317cf6;
    }

    .icon-item {
      width: 25%;
      margin-bottom: 12px;

      .icon {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #51a280;
        margin: 0 auto;
      }

      .name {
        font-size: 12px;
        text-align: center;
        margin-top: 3px;
      }
    }
  }

  .toolbox {
    overflow: hidden;
  }

  .toolbox::-webkit-scrollbar {
    width: 1px;
    display: flex;
  }

  .toolbox::-webkit-scrollbar-thumb {
    background: #3ba9f8;
  }

  .toolbox:hover {
    overflow-y: auto;
    width: calc(100% - 1px);
  }

  .tool-main {
    .tool-main-cont {
      justify-content: center;
      align-items: center;
      height: 450px;
      width: 450px;
      margin: 0 auto;
      // background-color: #006FFF;
      background-image: url("../assets/img/textform/bg.png");
      flex-direction: column;
    }
  }

  .getpromptBtn {
    width: 120px;
    height: 30px;
    background: #0b0b1f;
    border-radius: 14px;
    border: 1px solid #006fff;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #006fff;
    line-height: 28px;
  }
}

.eraser_type {
  cursor: url("../assets/img/textform/eraser1.png") 12 12, auto;
}
.pen_type {
  cursor: url("../assets/img/textform/pen1.png") 12 12, auto;
}

.img-cont {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background-color: #f5f6f9;
  margin: 0 auto;
}

.bottom-cont {
  box-sizing: border-box;
  border: none;
  max-height: 124px;
  padding: 10px 0;
  //min-height: 66px;
  background: #222337;
  border-radius: 10px;

  textarea {
    border: none;
    resize: none;
    cursor: pointer;
  }
}

.history {
  text-align: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;
  background: #111225;

  .title {
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  ::v-deep .el-tabs__item.is-active .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: #006fff;
    border-radius: 2px;
    position: absolute;
    bottom: 2px;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: transparent !important;
  }

  ::v-deep .el-tabs__item.is-active .t1:after {
    left: 30px;
  }

  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 37px;
  }

  ::v-deep .el-tabs__header.is-top {
    margin-bottom: 11px;
  }

  .scroll-cont {
    height: calc(100% - 25px);
    position: relative;
  }

  .scroll-cont {
    overflow: hidden;
  }

  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }

  .scroll-cont::-webkit-scrollbar-thumb {
  }

  .scroll-cont:hover {
    overflow-y: auto;
    // width: calc(100% - 1px )
  }

  .his-item {
    box-sizing: border-box;
    border-radius: 5px;
    flex-wrap: wrap;
    width: 130px;
    height: 130px;
    margin-bottom: 5px;
    align-content: stretch;
    position: relative;
    overflow: hidden;
    margin-right: 10px;
    .imgB1 {
      width: 130px;
      height: 130px;
    }

    .imgB2 {
      width: 65px;
      height: 130px;
    }

    .imgB3 {
      width: 65px;
      height: 65px;
    }

    .imgB4 {
      width: 65px;
      height: 65px;
    }

    img {
      width: 50%;
      height: 50%;
    }
    .top_model {
      position: absolute;
      top: 0;
      width: 100%;
      left: 0;
      right: 0;
      height: 34px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      z-index: 10;
      display: none;
    }
    .deleteIcon {
      display: none;
    }
  }

  // .his-item:nth-child(2n+2) {
  //   margin-right: 10px;
  // }

  .his-item:hover {
    .top_model {
      display: block;
    }
    .deleteIcon {
      display: block;
    }
  }
}

.carousel-cont .carousel-caption {
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
}

.exit_hover .arrowClickIcon {
  display: none;
}
.exit_hover:hover .arrowClickIcon {
  display: inline-block;
}

.getpromptBtn {
  width: 120px;
  height: 30px;
  background: #0b0b1f;
  border-radius: 14px;
  border: 1px solid #006fff;
  box-sizing: border-box;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #006fff;
  line-height: 28px;
}

.tool-main-cont {
  justify-content: center;
  align-items: center;
  height: 450px;
  width: 450px;
  margin: 0 auto;
  // background-color: #006FFF;
  background-image: url("../assets/img/textform/bg.png");
  flex-direction: column;
}
</style>
